$(document).ready(function(){
    var isMobile = $('.mobile-search-container').is(':visible');

    function initGlobalSearch() {
        var searchField = isMobile ? '#mobile-global-search-field' : '#desktop-global-search-field',
            searchResults = isMobile ? '#mobile-search-results-container' : '#desktop-search-results-container',
            buttonEvent = $('html').hasClass('touch') ? 'touchstart' : 'click';

        // Global Search Bar Settings
        settings = {
            form : $('input[name="form"]').val(),
            filters : {
                search_term : $( searchField ).val(),
                search_category : 'all',
                limit : 5,
                widget: null,
                template: 'event_search_results'
            },
            autoSearch : false,
            operation : $('input[name="search_type"]').val(),
            container : '.global-search-container',
            searchInput : searchField,
            resultContainer : searchResults,
            request : url('event_search', [$('input[name="form"]').val()]),
            saveSettings : false,
            onSuccess : function( data ){
                var $mainContainer = $(searchResults).closest('.quick-search'),
                    $columns = $mainContainer.find('.grid-unit');

                $mainContainer.addClass('active');
                createSearchLink();

                noResultsCheck( data.entities, settings.resultContainer );

                if ( $columns.length == 1 ) {
                    $columns.removeClass('six-twelfths four-twelfths');
                    $mainContainer.addClass('single-col');
                } else {
                    $mainContainer.removeClass('single-col');
                }

                UI.bindClickOut($mainContainer, function(){
                    $mainContainer.removeClass('active');
                });
            }
        }
        //instantiate the search
        var _globalSearch = new SystemSearch(settings);


        // Search Page Settings
        var fullSearch = $('#global-search-field-full').length,
            urlQueryString = window.location.search;

        if ( fullSearch ) {
            //define the settings needed for search
            full_settings = {
                autoSearch : false,
                form : $('input[name="form"]').val(),
                filters : {
                    search_category : 'all',
                    full_search: true,
                    template: 'event_search_results_full'
                },
                operation : $('input[name="search_type_full"]').val(),
                container : '.global-search-container-full',
                searchInput : '#global-search-field-full',
                resultContainer : '#search-results-container-full',
                request : url('event_search', [$('input[name="form"]').val()]),
                saveSettings : false,
                onSuccess : function( data ) {
                    noResultsCheck( data.entities, full_settings.resultContainer );
                }
            }
            //instantiate the search
            var _globalSearchFull = new SystemSearch(full_settings);
        }

        if ( fullSearch && urlQueryString ) {
            var urlQuery = urlQueryString.replace(/\?q\=/, ''),
                searchQuery = urlQuery.replace('%20', ' ');

            if ( urlQuery == 'recent_participants' ){
                _globalSearchFull.settings.filters.search_category = 'recent_participants';
                _globalSearchFull.triggerSearch();
            }  else if ( urlQuery.indexOf("recent_qgiv_participants") >= 0) {
                var getValues = urlQuery.split("&");
                var widgetValue = getValues[1].split("=");
                _globalSearchFull.settings.filters.search_category = 'recent_qgiv_participants';
                _globalSearchFull.settings.filters.widget = widgetValue[1];
                _globalSearchFull.triggerSearch();
            } else {
                $( full_settings.searchInput ).val( searchQuery ).trigger('keyup');

                if ( searchQuery.length <= _globalSearchFull.settings.searchThreshold ) {
                    _globalSearchFull.triggerSearch();
                }
            }
        }

        // Mobile Event Listeners
        $('.mobile-search-button').off(buttonEvent).on(buttonEvent, function(e) {
            var $this = $(this),
                $mobileContainer = $('.mobile-search-container'),
                searchIcon = $this.attr('data-search-icon'),
                closeIcon = $this.attr('data-close-icon');

            e.preventDefault();

            // Fixes scrolling bug on iOS
            $('html,body').scrollTop(0);

            $this.toggleClass('active');
            $mobileContainer.toggleClass('active');

            if ( $mobileContainer.is('.active') ) {
                // Add overflow hidden to the body to prevent background scrolling
                $('body').addClass('mobile-search-active');
                setTimeout(function() {
                    $this.text( closeIcon );
                }, 200);
                // Prevents form field navigation on touch devices
                $(':input').not( searchField ).prop('disabled', true);
                $( searchField ).focus();
            } else {
                $( searchField ).val('').blur();
                $('body').removeClass('mobile-search-active');
                $mobileContainer.find('.quick-search').removeClass('active').end()
                    .find('.no-results-message').addClass('hide-content');
                $this.text( searchIcon );
                $(':input').not( searchField ).prop('disabled', false);
            }
        });

        $('#global-search-form .global-search-field').off('keydown').on('keydown', function( event ) {
            if ( event.keyCode == 13 ) {
                event.preventDefault();
                return false;
            }
        });

        $(window).resize(function() {
            var state = $('.mobile-search-container').is(':visible');

            if ( state === isMobile ) {
                // Do nothing
            } else {
                isMobile = state;

                if ( $('.mobile-search-active').length ) {
                    $('.mobile-search-button').trigger( buttonEvent );
                }

                initGlobalSearch();
            }
        });
    }

    function createSearchLink() {
        var query = $( settings.searchInput ).val(),
            urlQuery = '?q=' + query.replace(' ', '%20');

        if ( !window.location.origin ) {
            // IE Doesn't support .origin
            window.location.origin = window.location.protocol + "//" + window.location.hostname
        }
        var viewAllURL = window.location.origin + '/event/' + $('#form-id').val() + '/search' + urlQuery;

        $('.view-all-link .link').attr('href', viewAllURL);
    }

    function noResultsCheck( resultCount, container ) {
        if ( resultCount == 0 ) {
            $( container ).append( '<div class="grid-unit no-results-message text-center"><p class="no-margin-top">No Search Results</p></div>' )
        } else {
            $( container ).find('.no-results-message').remove();
        }
    }

    // Initialize
    initGlobalSearch();
});